<script setup>
import { trans } from '@elements/translation';
import { EVENT_SLIDERS } from '../../general/event-constants';
import useInvoiceModalStore from '../../store/invoiceModal';

const emit = defineEmits([ 'openModal' ]);
const modalStore = useInvoiceModalStore();

const props = defineProps({
  status: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
});

const emitClick = () => {
  modalStore.setDetails({
    status: props.status,
    type: props.type,
  });

  emit('openModal', {
    title: trans(`gestion.invoices.slider.${props.type}.mark_as_${props.status}`),
    name: EVENT_SLIDERS.UPDATE_INVOICE_STATUS,
  });
};
</script>

<template>
  <li @click="emitClick">
    <span>{{ trans(`gestion.invoices.slider.${type}.mark_as_${status}`) }}</span>
  </li>
</template>
